import { Box, useTheme } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { Select, MenuItem } from '@mui/material';
import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { MutatingDots } from 'react-loader-spinner';
import { API_BASE } from "../../api";

const Surveys = (props) => {

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const columns = [
    { field: "id", headerName: "ID", renderCell: (row) => <Link to={`/survey-detail/${row.id}`} >{row.id}</Link> },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "phone",
      headerName: "Phone Number",
      flex: 1,
    },
    {
      field: "age",
      headerName: "Age",
      flex: 1,
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
    },

    {
      field: "income",
      headerName: "Income",
      flex: 1,
    },
    {
      field: "business",
      headerName: "Business",
      flex: 1,
    },
  ];

  const [users, setUsers] = useState([]);
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [currentUserName, setCurrentUserName] = useState('Select Reseacher')
  const [currentStateName, setCurrentStateName] = useState('Select State');
  const [currentStateId, setCurrentStateId] = useState(null);
  const [currentDistId, setCurrentDistId] = useState('');
  const [currentDistrictName, setCurrentDistrictName] = useState('Select District');
  const [surveyData, setSurveyData] = useState([]);
  const [currentUserId, setCurrentUserId] = useState('')
  const [loading, setLoading] = useState(false);

  const fetchUserData = async () => {
    try {
      await fetch(`${API_BASE}/researchers?districtId=${currentDistId}&state_id=${currentStateId}&role=${props.role}`).then((res) => {
        return res.json()
      }).then(data => {
        if(data?.result?.length !== 0){
        setUsers(data.result);
        }else{
          setCurrentUserName('No Researcher(s) Found!')
        }
        setLoading(false);
      })
    }
    catch (e) {
      console.log(e)

    }
  };

  const fetchSurveyData = () => {
    try {
      fetch(`${API_BASE}/surveys?userId=${currentUserId}&districtId=${currentDistId}&role=${props.role}`).then((res) => {
        return res.json()
      }).then(data => {
        setSurveyData(data.result);
        setLoading(false);
      })
    }
    catch (e) {
      console.log(e)
    }
  }

  const fetchDistrict = async () => {
    await fetch(`${API_BASE}/districts?state_id=${currentStateId}`)
      .then(response => response.json())
      .then(data => {
        setDistricts(data?.result.districtList);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetch(`${API_BASE}/states`).then(response => {
      return response.json()
    }).then(data => {
      setStates(data.result);
    })
  }, [])

  useEffect(() => {
    currentDistId && fetchUserData();
  }, [currentDistId]);

  useEffect(() => {
    currentUserId && fetchSurveyData();
  }, [currentUserId])

  useEffect(() => {
    currentStateId && fetchDistrict()
  }, [currentStateId]);


  const handleState = (event) => {
    const selectedName = states.find((state) => state.id === event.target.value)?.name;
    setCurrentStateName(selectedName);
    setCurrentStateId(event.target.value);
    setCurrentUserId('');
    setCurrentUserName('Select Reseacher');
    setCurrentDistrictName('Select District');
    setCurrentDistId('');
    setSurveyData([]);
    fetchDistrict();
    setLoading(true);

  };

  const handleDistrict = (event) => {
    const selectedName = districts.find((district) => district.id === event.target.value)?.name;
    setCurrentDistrictName(selectedName);
    setCurrentDistId(event.target.value);
    setCurrentUserId('');
    setCurrentUserName('Select Reseacher');
    setSurveyData([]);
    setUsers([]);
    setLoading(true);
  };

  const handleUser = async (event) => {
    const selectedName = users.find((user) => user.id === event.target.value)?.name;
    setCurrentUserName(selectedName);
    setCurrentUserId(event.target.value);
    setLoading(true);

  };

  return (
    <Box m="20px">
      <Header title="Surveys" subtitle="List of surveys" />
      <Box display="flex" justifyContent="flex-start" width="90%" p={2}>
    {/* Rest of your component */}
    </Box>
      <Box display="flex" justifyContent="flex-start" width="90%">
        {/* states */}
        <Box
          display="flex"
          backgroundColor={colors.primary[400]}
          borderRadius="3px"
          width="250px"
          marginRight="20px"
        >

          <Select
            sx={{
              ml: 2,
              flex: 1,
              minWidth: '100px',
              marginLeft: '0px'
            }}
            onChange={handleState}
            value={currentStateName}
          >
            <MenuItem value={currentStateName} disabled>
              {currentStateName}
            </MenuItem>
            {states && states.map((state) => (
              <MenuItem key={state.id} value={state.id}>
                {state.name}
              </MenuItem>
            ))}
          </Select>
        </Box>
        {/* districts */}
        {
          districts ? (
            <Box
              display="flex"
              backgroundColor={colors.primary[400]}
              borderRadius="3px"
              width="250px"
              marginRight="20px"
            >
              <Select
                sx={{
                  ml: 2,
                  flex: 1,
                  minWidth: '100px',
                  marginLeft: '0px'
                }}
                onChange={handleDistrict}
                value={currentDistrictName}

              >
                <MenuItem value={currentDistrictName} disabled>
                  {currentDistrictName}
                </MenuItem>
                {districts && districts.map((district) => (
                  <MenuItem key={district.id} value={district.id}>
                    {district.name}
                  </MenuItem>
                ))}
              </Select>
            </Box>
          ) : null
        }

        {/* researchers */}
        <Box
          display="flex"
          backgroundColor={colors.primary[400]}
          borderRadius="3px"
          width="250px"
          marginRight="20px"
        >

          <Select
            sx={{
              ml: 2,
              flex: 1,
              minWidth: '100px',
              marginLeft: '0px'
            }}
            onChange={handleUser}
            value={currentUserName}
          >
            <MenuItem value={currentUserName} disabled>
              {currentUserName}
            </MenuItem>
            {users && users.map((user) => (
              <MenuItem key={user.id} value={user.id}>
                {user.name}
              </MenuItem>
            ))}
          </Select>
        </Box>

      </Box>
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        {!loading ? (<DataGrid
          rows={surveyData}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
        />) :
          (<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh' }}> <MutatingDots
            height="100"
            width="100"
            color="#ED3237"
            secondaryColor='#ED3237'
            radius='12.5'
            ariaLabel="mutating-dots-loading"
            wrapperStyle={{}}
            wrapperClass=""
            visible={true}
            style={{
              left: "30%",
              backgroundColor: "#f0f0f0",
              borderRadius: "50%",
              boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
            }}
          /></div>)}

      </Box>
    </Box>
  );
};

export default Surveys;
